import LocalImage from '@atoms/LocalImage';
import { Button, Text, View } from '@components/primitives';
import { scale } from '@utils/normalize';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, BackHandler } from 'react-native';
import RNRestart from 'react-native-restart';
import styles from './styles';
// Import package from node modules

const DowntimeScreen = () => {
  const { t } = useTranslation('common');
  const tryAgain = () => {
    // reloads app
    if (Platform.OS === 'web') {
      window.location.reload();
    } else {
      // Optional: you may want to navigate to Splash or restart logic
      RNRestart.restart(); // if using react-native-restart
    }
  };

  const closeApp = () => {
    if (Platform.OS !== 'web') {
      BackHandler.exitApp();
    }
  };
  return (
    <View flex={1} justifyContent="center" alignContent="center">
      <LocalImage source={require('@assets/maintenance.gif')} resizeMode="stretch" style={styles.image} />
      <View alignContent="center" justifyContent="center" padding={5}>
        <Text variant="lg-normal" textAlign="center" marginBottom={5}>
          {t('common.maintenanceText')}
        </Text>
        <View flexDirection="row" alignContent="center" justifyItems="space-between" marginY={15}>
          <Button variant="ghost" onPress={tryAgain} flex={1} marginX={scale(5)} paddingY={scale(8)}>
            {t('common.refreshAndCheck')}
          </Button>
          {Platform.OS !== 'web' && (
            <Button
              size="lg"
              variant="solid"
              onPress={closeApp}
              color="red"
              flex={1}
              marginX={scale(5)}
              paddingY={scale(8)}>
              {t('common.closeApp')}
            </Button>
          )}
        </View>
      </View>
    </View>
  );
};

export default DowntimeScreen;
